<div *vsLet="selectedAddons$ | async as selectedAddons" class="flex flex-col">
  <ng-container *vsLet="addonPrices$ | async as addonPrices">
    <ng-container *ngFor="let addon of addons?.addons; let index = index; let first = first; let last = last">
      <ng-container
        *vsLet="
          addonPrices
            ? addonPrices[addon.addonId]
            : { price: 0, hasOneTime: true, installments: [], duration: 0 } as prices
        "
      >
        <!-- price template -->
        <ng-template #addonPrice>
          <ng-container *ngIf="prices.price">
            <div
              [vsTooltip]="
                (prices.hasOneTime && prices.installments.length) || prices.installments.length > 2
                  ? { template: pricesTooltip }
                  : undefined
              "
              tooltipStyle="light"
              tooltipPosition="top"
            ></div>

            <!--extra price tooltip -->
            <ng-template #pricesTooltip>
              <div>
                <p *ngIf="prices.hasOneTime">
                  <span>
                    {{ prices.price / 100 | currency: 'USD' : 'symbol' : '1.2-2' }}
                  </span>
                  <span>/one-time payment </span>
                </p>
                <p *ngFor="let installment of prices.installments">
                  <span>
                    {{ installment.price / 100 | currency: 'USD' : 'symbol' : '1.2-2' }}
                  </span>
                  <span>/{{ installment.count | installment: prices.duration }} </span>
                </p>
              </div>
            </ng-template>
          </ng-container>
        </ng-template>

        <ng-container *vsLet="addon.addonId | isSelected: selectedAddons as selected">
          <ng-container *ngIf="addon.addonId.startsWith('cov'); else group">
            <div
              class="max-w-[600px] flex flex-col w-full border rounded-xl bg-base-white gap-0"
              [class.border-primary-500]="selected"
              [class.mb-4]="!last"
              [class.opacity-50]="!isDependencyMet(addon.addonId) && !selected"
            >
              <div class="flex justify-between w-full items-center p-4 gap-2 text-sm">
                <div class="flex items-center gap-2 min-w-0 overflow-hidden">
                  <input
                    type="checkbox"
                    vsInput
                    #checkbox
                    [checked]="selected"
                    [disabled]="!isDependencyMet(addon.addonId) && !selected"
                    (change)="checkbox.checked ? selectAddon(addon.addon.id) : deselectAddon(addon.addon.id)"
                  />

                  <button (click)="CoverageDialog.open()" class="flex items-center gap-1 min-w-0">
                    <span class="truncate min-w-0">{{ addon.addon.title }}</span>
                    <vs-icon name="info-circle" size="14" class="text-gray-500 flex-shrink-0"></vs-icon>
                  </button>

                  <!-- price -->
                  <ng-container [ngTemplateOutlet]="addonPrice"></ng-container>
                </div>

                <span
                  *ngIf="prices.hasOneTime || !prices.installments.length ? prices.price : 0 as price"
                  class="whitespace-nowrap flex-shrink-0"
                  data-testid="addon-price"
                >
                  +
                  <ng-container *ngIf="prices.hasOneTime || !prices.installments.length; else monthly">
                    {{ (price || 0) / 100 | currency: 'USD' : 'symbol' : '1.2-2' }}
                    /one-time payment
                  </ng-container>
                  <ng-template #monthly>
                    {{ (price || 0) / 100 / 12 | currency: 'USD' : 'symbol' : '1.2-2' }}
                    <ng-container *ngIf="prices.installments[0]">
                      /{{ prices.installments[0].count | installment: prices.duration }}
                    </ng-container>
                  </ng-template>
                </span>
              </div>

              <!-- Dependency hint -->
              <div *ngIf="getDependencyHint(addon.addonId) as hint" class="px-4 pb-3 -mt-1 flex items-center gap-1">
                <vs-icon name="lock-01" size="12" class="text-gray-400 flex-shrink-0"></vs-icon>
                <span class="text-xs text-gray-400">{{ hint }}</span>
              </div>
            </div>

            <ng-template #AddonAggLimit>
              <ng-container
                [ngTemplateOutlet]="AggLimit"
                [ngTemplateOutletContext]="{ coverage: addon.coverages[0] }"
              ></ng-container>
            </ng-template>

            <ws-preview-group-addons
              #CoverageDialog
              [addon]="addon"
              [checked]="selected ?? false"
              (selected)="$event ? selectAddon(addon.addonId) : deselectAddon(addon.addon.id)"
            ></ws-preview-group-addons>
          </ng-container>

          <ng-template #group>
            <div
              class="p-4 border rounded-xl bg-base-white"
              [class.border-primary-500]="selected"
              [class.mb-4]="!last"
              [class.opacity-50]="!isDependencyMet(addon.addonId) && !selected"
            >
              <vs-accordion [open]="true" #addonGroupAccordion>
                <ws-coverage-accordion-header
                  slot="header"
                  [header]="addon.addon.title"
                  [minimize]="true"
                  [checkbox]="true"
                  [select]="!!selected"
                  [disabled]="!isDependencyMet(addon.addonId) && !selected"
                  [open]="addonGroupAccordion.open"
                  (toggled)="addonGroupAccordion.toggle()"
                  (selected)="$event ? selectAddon(addon.addon.id) : deselectAddon(addon.addon.id)"
                >
                  <div slot="post-title">
                    <ng-container [ngTemplateOutlet]="addonPrice"></ng-container>
                  </div>
                  <vs-icon
                    slot="header-end"
                    [vsTooltip]="
                      'To view the limits of liability for ' +
                      addon.addon.title +
                      ', expand this bundle to view the individual coverages'
                    "
                    tooltipMaxWidth="xs"
                    tooltipStyle="light"
                    name="minus"
                  ></vs-icon>
                </ws-coverage-accordion-header>

                <!-- Coverages -->
                <div slot="content" class="flex flex-col gap-2 py-2 text-sm">
                  <ng-container *ngFor="let coverage of addon.coverages">
                    <div *vsLet="coverage.price as price" class="flex justify-between items-center gap-2">
                      <button
                        type="button"
                        class="flex items-center gap-1 min-w-0 flex-1 text-start"
                        (click)="CoverageDialog.open()"
                      >
                        <span class="truncate">{{ coverage.coverage?.title }}</span>
                        <vs-icon
                          name="info-circle"
                          size="14"
                          class="text-gray-500 flex-shrink-0"
                          [vsTooltip]="'View additional addon information'"
                        ></vs-icon>
                      </button>
                      <span
                        class="whitespace-nowrap flex-shrink-0"
                        [vsTooltip]="
                          coverage.liabilityGroupObjects?.length ? { template: GroupAddonAggLimit } : undefined
                        "
                        tooltipStyle="light"
                        tooltipMaxWidth="md"
                      >
                        +
                        {{ (price || 0) / 100 | currency: 'USD' : 'symbol' : '1.2-2' }}
                      </span>
                    </div>
                    <ng-template #GroupAddonAggLimit>
                      <ng-container
                        [ngTemplateOutlet]="AggLimit"
                        [ngTemplateOutletContext]="{ coverage }"
                      ></ng-container>
                    </ng-template>
                  </ng-container>
                </div>
              </vs-accordion>

              <!-- Dependency hint for group addons (below the title) -->
              <div *ngIf="getDependencyHint(addon.addonId) as hint" class="pt-2 flex items-center gap-1">
                <vs-icon name="lock-01" size="12" class="text-gray-400 flex-shrink-0"></vs-icon>
                <span class="text-xs text-gray-400">{{ hint }}</span>
              </div>
            </div>
            <ws-preview-group-addons
              #CoverageDialog
              [addon]="addon"
              [selectedAddon]="index"
              [checked]="selected ?? false"
              (selected)="$event ? selectAddon(addon.addonId) : deselectAddon(addon.addon.id)"
            ></ws-preview-group-addons>
          </ng-template>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</div>

<ng-template #AggLimit let-coverage="coverage">
  <div class="flex flex-col gap-2 pb-2">
    <div class="text-xs">Aggregate limits for {{ coverage.coverage?.title }}</div>
    <div class="flex flex-col min-w-[200px] outline outline-gray-200 rounded-lg">
      <div
        class="flex justify-between py-3 px-6 text-left text-xs font-medium text-gray-600 bg-base border-b border-gray-200 whitespace-nowrap"
      >
        <div>Title</div>
        <div>Limit</div>
      </div>
      <div class="flex flex-col">
        <ng-container *ngFor="let group of coverage.liabilityGroupObjects; let index = index">
          <div
            class="flex justify-between bg-base py-2 px-6 border-b border-gray-200"
            [class.bg-gray-50]="index % 2 === 1"
          >
            <div>{{ group.title }}</div>
            <div>{{ group.limit / 100 | currency }}</div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>
